import React from 'react';

const Shop = () => {
  return (
    <div className="shop-page">
      <div className="container">
        <h1>Shop</h1>
        <p>This is the shop page. Content will be added here.</p>
      </div>
    </div>
  );
};

export default Shop;
